export { MiniLegend } from './MiniLegend';
